export class Disclaimer {

  // For Firebase
  $key: string;

  hasMenuScreenDisclaimer: boolean;
  menuScreenDisclaimer: string;

  hasAboutDisclaimer: boolean;
  aboutDisclaimer: string;

  hasVenueDisclaimer: boolean;
  venueDisclaimer: string;

  hasSessionListDisclaimer: boolean;
  sessionListDisclaimer: string;

  hasSessionDetailsDisclaimer: boolean;
  sessionDetailsDisclaimer: string;

  hasSpeakerListDisclaimer: boolean;
  speakerListDisclaimer: string;

  hasSpeakerDetailsDisclaimer: boolean;
  speakerDetailsDisclaimer: string;

  hasOrganizerListDisclaimer: boolean;
  organizerListDisclaimer: string;

  hasSponsorListDisclaimer: boolean;
  sponsorListDisclaimer: string;

  hasExhibitorListDisclaimer: boolean;
  exhibitorListDisclaimer: string;

  hasQnaDisclaimer: boolean;
  qnaDisclaimer: string;

  hasPollsDisclaimer: boolean;
  pollsDisclaimer: string;

  constructor(){
  
  }

}



// WEBPACK FOOTER //
// /app/src/app/core/models/disclaimer.ts